import {
  CONVERSATION_FACTS_DIMENSIONS,
  CONVERSATION_FACTS_ZONE_DIMENSIONS,
} from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

/**
 * Base cube query for the median conversation length drill down view. Median conversation length is defined as the duration between the first interaction and first close in seconds.
 */
export const MedianConversationLengthDrillDownBase: CubeQuery = {
  name: 'MedianConversationLengthDrillDown',
  queryName: 'MedianConversationLengthDrillDown',
  query: {
    dimensions: [
      CONVERSATION_FACTS_ZONE_DIMENSIONS.CONVERSATION_CREATED_AT,
      CONVERSATION_FACTS_DIMENSIONS.DURATION_BETWEEN_FIRST_INTERACTION_AND_FIRST_CLOSE_MS,
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_CREATED_FROM_URL,
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_ID,
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_STATUS,
    ],
    order: [
      [CONVERSATION_FACTS_ZONE_DIMENSIONS.CONVERSATION_CREATED_AT, 'desc'],
    ],
  },
}
